/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * **EXPERIMENTAL** - This icon is still under development, and may change visually.
 *
 *![ExperimentalLootboxIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1UlEQVR4nO1VXQrCMAzug3oMPcreZflBGIk7wK7iPJDDCzgv4s+Lgp5gUtQxppPiOlDxg0BJ23xNmh9j/nBBFEUDZJkDyQ5ZizYCLFtkTa3NksAq2hrGR0lLAh8vx7qQ7qseFF2I+SgCYF0B65RIYiTJvRIAyyIIgt79vF0jaeZMAKTHRuOkpzCMhvXUtjq713xPDuZ3AG+EaDyJR8hydgqRQ9Fk1U9OkqQPLEu/dUCS2xS9pqmuv6/QsA3BrcX6Jth02q6BdFYbOJr68ASeDZw/zAtcAF6Ng/LzgwRgAAAAAElFTkSuQmCC)
 */
export const ExperimentalLootboxIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23 6a3 3 0 0 0-3-3H4a3 3 0 0 0-3 3v4.5c0 .28.22.5.5.5h7c.22 0 .41-.14.5-.34.53-1.3 1.68-2.41 3-2.41s2.47 1.11 3 2.4c.09.2.28.35.5.35h7a.5.5 0 0 0 .5-.5V6ZM23 13.5a.5.5 0 0 0-.5-.5h-7c-.22 0-.41.14-.5.34-.53 1.3-1.68 2.41-3 2.41s-2.47-1.11-3-2.4a.54.54 0 0 0-.5-.35h-7a.5.5 0 0 0-.5.5V18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-4.5Z"
        className={colorClass}
      />
    </svg>
  );
};
